import jwtDecode from 'jwt-decode';
import { useState, useEffect } from 'react';

import justLogo from '../images/justlogo500.png';
import BackLinkButton from '../components/BackLinkButton.jsx';
import UserHeader from '../components/UserHeader.jsx';
import UserSquare from '../components/UserSquare.jsx';
import AddNewRobaButton from '../components/AddNewRobaButton.jsx';
import LoaderModal from '../components/LoaderModal.jsx';
import UserObjectBox from '../components/UserObjectBox.jsx';

const MyRoba = () => {

  const userToken = localStorage.getItem('loggedUser');
  const decodedToken = jwtDecode(userToken);

  //----- CHIAMATA FETCH PER RICEVERE GLI OGGETTI -----//

  const [objectsArray, setObjectsArray] = useState(null);
  const [isFetchPending, setIsFetchPending] = useState(false);
  const userId = decodedToken.id

  const getUserRoba = async () => {

    setIsFetchPending(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/users/userObjects/${userId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json'
        }
      })

      if(response.ok) {
        const robaOfUser = await response.json();
        setObjectsArray(robaOfUser.newRobaArray);
      } else {
        console.log('Errore durante la chiamta al server');
      }
    } catch (error) {
      console.log('Error type: ', error)
    }

    setIsFetchPending(false);

  }

  useEffect(() => {
    getUserRoba();
  }, [])

  useEffect(() => {
    console.log('objectArray: ', objectsArray);
  }, [objectsArray])

  //-----//


  return (
    <div className="container">
      <img src={justLogo} style={{width: '50px'}}/><h2>LA MIA ROBA</h2>
      <BackLinkButton />
      <UserHeader user={{
        id: decodedToken.id,
        avatarUrl: decodedToken.avatar.url,
        name: decodedToken.name,
        surname: decodedToken.surname,
        position: decodedToken.position
      }} />

      <div className="roba-object-list-box">
        {
          objectsArray &&
          objectsArray.map((element, index) => (
            <UserObjectBox key={index} objectData={element} userId={decodedToken.id} token={userToken}/>
          ))

        }
      </div>

      {isFetchPending && <LoaderModal isFetchPending={isFetchPending} />}

      <AddNewRobaButton />
    </div>
  )
}

export default MyRoba;
